module.exports = __webpack_public_path__ + "static/media/glencullen.645264de.png";